'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_UsersEditRequestForm(user, organization) {
  this.Bn = null;
  this.Bm = null;
  this.Bn = user;
  this.Bm = organization;
}
export { $c_Lapp_api_UsersEditRequestForm as $c_Lapp_api_UsersEditRequestForm };
$p = $c_Lapp_api_UsersEditRequestForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_UsersEditRequestForm;
/** @constructor */
function $h_Lapp_api_UsersEditRequestForm() {
}
export { $h_Lapp_api_UsersEditRequestForm as $h_Lapp_api_UsersEditRequestForm };
$h_Lapp_api_UsersEditRequestForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_UsersEditRequestForm)) {
    var x = this.Bn;
    var x$2 = x$0.Bn;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Bm;
      var x$4 = x$0.Bm;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "UsersEditRequestForm";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Bn;
  }
  if ((n === 1)) {
    return this.Bm;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "user";
  }
  if ((n === 1)) {
    return "organization";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_UsersEditRequestForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iB)));
}
export { $isArrayOf_Lapp_api_UsersEditRequestForm as $isArrayOf_Lapp_api_UsersEditRequestForm };
var $d_Lapp_api_UsersEditRequestForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_UsersEditRequestForm, "app.api.UsersEditRequestForm", ({
  iB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_UsersEditRequestForm as $d_Lapp_api_UsersEditRequestForm };
//# sourceMappingURL=app.api.-Users-Edit-Request-Form.js.map
